import {
  Cancel as CancelIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { Autocomplete, CircularProgress, IconButton } from '@mui/material';
import { isEmpty, isNil } from 'lodash';
import { useEffect, useState } from 'react';

import { SearchBarProps } from './SearchBar.interface';
import { SearchField } from './SearchBar.styled';

export const SearchBar = (props: SearchBarProps) => {
  const [searchedValue, setSearchedValue] = useState(props.value || '');
  const [searchInputValue, setSearchInputValue] = useState<string>('');

  useEffect(() => {
    setSearchedValue(props.value || '');
    if (props.resetVal) {
      setSearchInputValue('');
      if (props.onResetComplete) {
        props.onResetComplete();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.resetVal, props.value]);

  const onChange = (event: React.SyntheticEvent, value: any) => {
    if (props.onChange && !isNil(value) && searchInputValue !== '') {
      const values: string | string[] = value;
      props.onChange(values);
    }
  };

  const onInputChange = (event: React.SyntheticEvent, value: string | null) => {
    setSearchInputValue(value ?? '');
    if (props.onInputChange && !isNil(value)) {
      const values = Array.isArray(value)
        ? value.map((item) => item.trim())
        : value.trim();
      props.onInputChange(values);
    }
  };

  const onClear = () => {
    setSearchedValue('');
    setSearchInputValue('');
    if (props.onInputChange) {
      props.onInputChange('');
    }
  };

  return (
    <Autocomplete
      freeSolo
      multiple={props.multiple}
      options={props.autocompleteOptions || []}
      onInputChange={onInputChange}
      onChange={onChange}
      value={searchedValue}
      inputValue={searchInputValue}
      renderInput={(params) => (
        <SearchField
          {...params}
          $height={props.height}
          onKeyDown={props.onKeyDown}
          InputProps={{
            startAdornment: (
              <IconButton size="small">
                <SearchIcon />
              </IconButton>
            ),
            endAdornment: props.isLoading ? (
              <CircularProgress size={24} />
            ) : (
              !isEmpty(searchInputValue) &&
              props.onInputChange && (
                <IconButton size="small" onClick={onClear}>
                  <CancelIcon />
                </IconButton>
              )
            ),
          }}
          placeholder={props.placeholder}
        />
      )}
    />
  );
};
